import { render, staticRenderFns } from "./TagCreateUpdate.vue?vue&type=template&id=0c5bf3f6"
import script from "./TagCreateUpdate.vue?vue&type=script&lang=js"
export * from "./TagCreateUpdate.vue?vue&type=script&lang=js"
import style0 from "./TagCreateUpdate.vue?vue&type=style&index=0&id=0c5bf3f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports